/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Verification Status
 */
export type PostBankAccountUserDataResponseVerificationStatus = typeof PostBankAccountUserDataResponseVerificationStatus[keyof typeof PostBankAccountUserDataResponseVerificationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostBankAccountUserDataResponseVerificationStatus = {
  verified: 'verified',
  pending: 'pending',
  failed: 'failed',
} as const;
